module.exports = __webpack_public_path__ + "img/worksbot_img19112521.4bc018c1.jpg";